// @flow

import React from "react";
import { ImageBackground, View, StyleSheet } from "react-native";
import basketLogo from "@/assets/basket-logo.png";

type BasketLogoProps = {
  isBasketEmpty: boolean;
};

const BasketLogo = ({ isBasketEmpty = true }: BasketLogoProps): JSX.Element => {
  const containerStyle = isBasketEmpty ? { opacity: 0.5 } : { opacity: 0.05 };
  return (
    <View
      testID="basketLogo"
      pointerEvents="none"
      style={[styles.container, { ...containerStyle }]}
    >
      <ImageBackground
        style={styles.imageBackground}
        resizeMode="contain"
        resizeMethod="auto"
        source={basketLogo}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    left: "35%",
    top: "30%",
    opacity: 0.5,
    zIndex: 15,
  },
  imageBackground: {
    height: 180,
    width: 180,
  },
});

export default BasketLogo;
